<nav class="navbar navbar-expand-lg navbar-light">
  <a class="navbar-brand"
     href="#">Renzo Barduagni</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">

      <li class="nav-item active">
        <a class="nav-link" routerLink="/app-home" routerLinkActive="active">Home</a>
      </li>

      <li class="nav-item active">
        <a class="nav-link" routerLink="/login" routerLinkActive="active">Area riservata</a>
      </li>

      <!--
        <li class="nav-item active">
            <a class="nav-link"
                href="#">Login</a>
        </li>
        <li class="nav-item active">
            <a class="nav-link"
                href="#">Reset Password</a>
        </li>
        -->
      </ul>
    </div>
</nav>